export const isItiOS = (userAgent: any) => {
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  return /iPad|iPhone|iPod|Macintosh/.test(userAgent);
};
